import {Component, OnInit, ViewChild} from '@angular/core';
import {Producto} from '../../_models/producto';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProductoService} from '../../_services/producto.service';
import {NavService} from '../../_services/_nav.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {Location} from '@angular/common';
import {ListaService} from '../../_services/lista.service';
import {firstValueFrom, forkJoin} from 'rxjs';
import {ListaItem} from '../../_models/lista-item';
import moment from 'moment';
import 'moment/locale/es';
import {CalendarioPropiedades} from '../../_models/calendario-propiedades';
import {FuenteIconos} from '../../_models/fuente-iconos';
import {ModalidadService} from '../../_services/modalidad.service';
import {ProductoAutorizacionService} from '../../_services/producto-autorizacion.service';
import {ComunicationComponentsService} from '../../_services/comunication-components.service';
import {ProductosPeriodosGraciasService} from '../../_services/productos-periodos-gracias.service';
import {ProductosPeriodosGracias} from '../../_models/productos-periodos-gracias';
import {ProductosPeriodosGraciasOtrosConceptosService} from '../../_services/productos-periodos-gracias-otros-conceptos.service';
import {ConceptoFacturacionService} from '../../_services/concepto-facturacion.service';
import {ConceptoFacturacion} from '../../_models/concepto-facturacion';
import {ProductosPeriodosGraciasOtrosConceptos} from '../../_models/productos-periodos-gracias-otros-conceptos';
import {AdjuntoService} from '../../_services/adjunto.service';
import {CreditosDigital, Listas, TasasProducto, TiposCuentaAhorro, TiposProductosBancarios} from '../../_enums/enum';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {AppSettings} from '../../../proyect.conf';
import {SafeResourceUrl} from '@angular/platform-browser';
import {ConstanteService} from '../../_services/constante.service';
import {FileUpload} from 'primeng/fileupload';
import {saveAs} from 'file-saver';
import {TasasVariablesService} from '../../_services/tasas-variables.service';
import {TasasVariables} from '../../_models/tasas-variables';
import {ProductosTasas} from '../../_models/productos-tasas';
import {ProductosTasasService} from '../../_services/productos-tasas.service';
import {ProductosMediosAsociadosService} from '../../_services/productos-medios-asociados.service';
import {ProductosSolicitudesLlaves} from '../../_models/productos-solicitudes-llaves';
import {ProductosMediosAsociados} from '../../_models/productos-medios-asociados';
import {ProductosSolicitudesLlavesService} from '../../_services/productos-solicitudes-llaves.service';
import {ProductoTipoInteresService} from '../../_services/producto-tipo-interes.service';
import {ProductoTipoInteres} from '../../_models/producto-tipo-interes';
import {ProductosAgremiacionesService} from '../../_services/productos-agremiaciones.service';
import {ProductosAgremiaciones} from '../../_models/productos-agremiaciones';
import {TerceroService} from '../../_services/tercero.service';
import {TerceroGremio} from '../../_models/terceros-gremios';

@Component( {
  selector: 'app-producto-editar',
  templateUrl: 'producto-editar.component.html'
} )

export class ProductoEditarComponent implements OnInit {

  producto: Producto;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  lisProducto: Producto[] = [];
  formulario: FormGroup;
  formularioPeriodoGracia: FormGroup;
  formularioConceptos: FormGroup;
  submitted = false;
  lisTabCargados = {
    producto: false,
    alerta: false,
    autorizacion: false,
    camposDigitales: false,
    confirmacionVincualcion: false,
    controlAnalizamos: false,
    control: false,
    cuestionarios: false,
    desembolso: false,
    destino: false,
    estado: false,
    estadoAliado: false,
    // formaDesembolso: false,
    frecuencias: false,
    frecuenciaAliado: false,
    flujoVentaPaso: false,
    hojaEvaluacion: false,
    monto: false,
    montodestino: false,
    montoAliado: false,
    seguroAnalizamos: false,
    referencia: false,
    reglaNegocio: false,
    renovacion: false,
    garantias: false,
    restricciones: false,
    voluntadPago: false,
    actividadAliado: false,
    historial: false,
    plancargo: false,
  };
  lisCupos: SelectItem[] = [];
  lisClasificaciones: SelectItem[] = [];
  calPropiedades: CalendarioPropiedades = new CalendarioPropiedades();
  maxFechaInicial: Date;
  minFechaFinal: Date;
  habProducto = false;
  lisFuentes: SelectItem[] = [];
  listaTiposCuotas: SelectItem[] = [];
  listaTipoCartera: SelectItem[] = [];
  lisTipoCarteras: ListaItem[] = [];
  lisModalidades: SelectItem[] = [];
  listaTipoTasasProductoTodas: ListaItem[] = [];
  listaTiposTasasProducto: SelectItem[] = [];
  listaTasasVariablesTodas: TasasVariables[] = [];
  listaTasasVariables: SelectItem[] = [];
  productoTasas: ProductosTasas[] = [];
  idTipoTasaProducto: any = [];
  relIndicadorAliadoOficina = false;
  ranIncorrecto = false;
  plaIncorrecto = false;
  ranPrimerPagoIncorrecto = false;
  plazoCorrecto = true;
  tabSeleccionado = 'PRODUCTO';
  tabViewIndex: number;
  listaTipoPeriodo: SelectItem[] = [];
  listaConceptos: SelectItem[] = [];
  listaConceptosAsignados: any[] = [];
  columnas: any[] = [];
  loadingConceptos = true;
  lisTercerosGremios: SelectItem[] = [];
  productosAgremiacionesGuardados: ProductosAgremiaciones[] = [];
  estadoValorMinimo = true;
  productosPeriodosGracias: ProductosPeriodosGracias = new ProductosPeriodosGracias();
  canales  = CreditosDigital;
  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  dataUploadArchivo: any = '';
  dataUploadUsuario: any = '';
  usuarioLogueado: any;
  fsize: number;
  ftype = 'image/png';
  errorTipoImagen: boolean;
  habilitarTasaVariable: boolean = false;
  listasSolicitudesTasasEspeciales: SelectItem[] = [];
  @ViewChild('adjunto') adjunto: FileUpload;

  listaTiposProductosBancarios: ListaItem[] = [];
  codeTipoProductoBancario: string;
  codeTipoCuentaAhorro: string;
  idTipoProductoBancario: string;
  codigosProducto = TiposProductosBancarios;
  tiposCuentaAhorro = TiposCuentaAhorro;

  listaTipoCuenta: SelectItem[] = [];
  lisTipoCuenta: ListaItem[] = [];

  listaTiposMediosAsociados: SelectItem[] = [];
  lisTiposMediosAsociados: ListaItem[] = [];

  listaTiposSolicitudesLlaves: SelectItem[] = [];
  lisTiposSolicitudesLlaves: ListaItem[] = [];


  productosMediosAsociados: ProductosMediosAsociados[] = [];
  productosSolicitudesLlaves: ProductosSolicitudesLlaves[] = [];
  idMediosAsociadosProducto: any = [];
  idSolicitudesLlavesProducto: any = [];
  listasTiposPersonas: SelectItem[] = [];

  productoTiposIntereses: ProductoTipoInteres[] = [];
  listaTipoTituloInversion: SelectItem[] = [];
  listaTipoInteres: SelectItem[] = [];
  listaCanalesCDTS: SelectItem[] = [];

  constructor( private proServicio: ProductoService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private location: Location,
               private modalidadService: ModalidadService,
               private lisServicio: ListaService,
               private proAutorizacionServicio: ProductoAutorizacionService,
               private navServicio: NavService,
               private commService: ComunicationComponentsService,
               private productosPeriodosGraciasService: ProductosPeriodosGraciasService,
               private productosPeriodosGraciasOtrosConceptosService: ProductosPeriodosGraciasOtrosConceptosService,
               private conceptoFacturacionService: ConceptoFacturacionService,
               private autServicio: AutenticacionService,
               private conConstanteService: ConstanteService,
               private adjuntosService: AdjuntoService,
               private tasasVariables: TasasVariablesService,
               private productosTasas: ProductosTasasService,
               private productosMediosAsociadosService: ProductosMediosAsociadosService,
               private productosSolicitudesService: ProductosSolicitudesLlavesService,
               private productoTipoInteresService: ProductoTipoInteresService,
               private productosAgremiacionesService: ProductosAgremiacionesService,
               private terceroService: TerceroService,
  ) {
  }

  ngOnInit(): void {
    this.tabViewIndex = 0;

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_CODIGO' ), sort: true },
      { field: 'concepto', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_NOMBRE' ), sort: true },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_ACCIONES' ), sort: true },
    ];

    const fuentes = new FuenteIconos();
    this.usuarioLogueado = this.autServicio.obtenerUsuario();
    fuentes.iconos.map( ( s: string ) => {
      this.lisFuentes.push( { label: s, value: s } );
    } );

    this.calPropiedades.actualizarRango( 40 );
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin([
          this.proServicio.obtenerPorId(params['id']),
          this.productoTipoInteresService.getByIdProducto(params['id']),
        ]).subscribe({
          next: async ([producto, productoTiposIntereses]) => {
            this.producto = producto;
            this.codeTipoProductoBancario = producto.codigoTipoProductoBancario;
            this.codeTipoCuentaAhorro = producto.codigoTipoCuentaAhorro ?? null;
            if ( this.producto.idAdjuntoIcono ) {
              this.cargarlogoInicial(this.producto.idAdjuntoIcono);
            }

            this.productoTiposIntereses = productoTiposIntereses;

            await this.carServiciosIniciales();
          }
        });
      } else {

        forkJoin(
         this.lisServicio.getMasterDetails('ListasTiposProductosBancarios'),
          this.proServicio.listado()
        ).subscribe(([tiposProductos, productos]  ) => {
          // Procesar tipos de productos bancarios
          this.listaTiposProductosBancarios = tiposProductos;

          const idTipoProductoBancario = params['idTipoProductoBancario'];
          this.codeTipoProductoBancario = idTipoProductoBancario
            ? tiposProductos.find(s => s.idLista === idTipoProductoBancario).codigo
            : 'CREDIT';

          this.idTipoProductoBancario =tiposProductos.find(s => s.codigo === this.codeTipoProductoBancario).idLista;

          // Procesar productos y ordenarlos
          this.lisProducto = productos.sort((a, b) => a.orden - b.orden);

          // Llamar a los servicios iniciales
          this.carServiciosIniciales();
        });
      }
    } );

  }

  cargarlogoInicial(idAdjuntoIcono) {
    this.adjuntosService.descargarArchivo( this.producto.idAdjuntoIcono ).subscribe( adjunto => {
      let reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = reader.result;
      }, false );
      if ( adjunto ) {
        reader.readAsDataURL( adjunto );
      }
    })
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.f.idAdjuntoIcono.setValue( respuesta.idAdjunto );
    }
  }

  onBeforeSend( event: any ) {
    this.adjuntosService.cargarArchivo( event, this.dataUploadArchivo, '/Crezcamos/Producto/Referencias' );
  }

  onSelect( event: any, file: any ) {
    if (this.adjunto.msgs.length === 0) {
      this.dataUploadArchivo = file[ 0 ].name;
      this.dataUploadUsuario = this.usuarioLogueado.idUsuario;
      this.f.nombreAdjuntoIcono.setValue( file[ 0 ].name );
      this.producto.nombreAdjuntoIcono = file[ 0 ].name;

      let reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = reader.result;
      }, false );
      if ( file[ 0 ] ) {
        reader.readAsDataURL( file[ 0 ] );
      }
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }

  }

  uploadingOk( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto != undefined ) {
      this.producto.idAdjuntoIcono = respuesta.idAdjunto;
      this.f.idAdjuntoIcono.setValue( respuesta.idAdjunto );
      console.log(this.producto);
    }
  }

  cambioEstadoCampos(e) {
    this.f.indicadorFlujoDigital.setValue( e.checked );
    if (this.producto) {
      this.producto.indicadorFlujoDigital = e.checked ;
    }
    if ( !e.checked ) {
      this.imagen = null;
      if (this.producto) {
        this.producto.idAdjuntoIcono = null;
        this.producto.nombreAdjuntoIcono = null;
        this.producto.idAdjuntoIcono = null;

      }
      this.f.idAdjuntoIcono.setValue( null );
      this.f.nombreAdjuntoIcono.setValue( null );
    }
    console.log(this.f);
  }

  uploadAgain( rta: boolean ) {
    this.producto.idAdjuntoIcono = null;
    this.producto.nombreAdjuntoIcono = null;
    this.f.idAdjuntoIcono.setValue( null );
    this.f.nombreAdjuntoIcono.setValue( null );
  }

  downloadFile( id: string ) {
    this.adjuntosService.descargarArchivo( id ).subscribe( res => {
      this.adjuntosService.obtenerNombreArchivo( id ).subscribe( adj => {
        console.log(adj);
        saveAs( res, adj.nombreArchivo );
      } );
    } );
  }

  async carServiciosIniciales() {
    this.formulario = this.fb.group({
      idProducto: [this.producto ? this.producto.idProducto : null],
      codigo: [this.producto ? this.producto.codigo : null, [Validators.required, Validators.maxLength(10)]],
      nombre: [this.producto ? this.producto.nombre : null, [Validators.required, Validators.maxLength(100)]],
      idModalidad: [this.producto ? this.producto.idModalidad : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required]
        : []],
      descripcion: [
        this.producto ? this.producto.descripcion : null,
        this.codeTipoProductoBancario != TiposProductosBancarios.PASARELA ? [Validators.required, Validators.maxLength(500)] : []
      ],
      idTipoCupoProducto: [this.producto ? this.producto.idTipoCupoProducto : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required]
        : []],
      idClasificacionProducto: [this.producto ? this.producto.idClasificacionProducto : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required]
        : []],
      fechaAprobacionActa: [this.producto ? this.producto.fechaAprobacionActa : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required]
        : []],
      fechaInicioVigencia: [
        this.producto ? this.producto.fechaInicioVigencia : null,
        this.codeTipoProductoBancario != TiposProductosBancarios.PASARELA ? [Validators.required] : []
      ],
      fechaFinVigencia: [
        this.producto ? this.producto.fechaFinVigencia : null,
        this.codeTipoProductoBancario != TiposProductosBancarios.PASARELA ? [Validators.required] : []
      ],
      codigoActaAprobacion: [this.producto ? this.producto.codigoActaAprobacion : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required, Validators.maxLength(20)]
        : []],
      tasa: [this.producto ? this.producto.tasa : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO ?
        (this.producto && this.producto.indicadorManejaTasa) ? [Validators.required, Validators.maxLength(9)] : [Validators.maxLength(9)]
        : []],
      tasaMaximaEspecial: [this.producto ? this.producto.tasaMaximaEspecial : null],
      indicadorComercializacionAliados: [this.producto ? this.producto.indicadorComercializacionAliados : false],
      indicadorComercializacionOficinas: [this.producto ? this.producto.indicadorComercializacionOficinas : false],
      indicadorFlujoDigital: [this.producto ? this.producto.indicadorFlujoDigital : false],
      indicadorManejaTasa: [this.producto ? this.producto.indicadorManejaTasa : false],
      idTipoAmortizacion: [this.producto ? this.producto.idTipoAmortizacion : null, this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO
        ? [Validators.required]
        : []],
      idTipoCartera: [this.producto ? this.producto.idTipoCartera : null],
      indicadorRenovable: [this.producto ? this.producto.indicadorRenovable : false],
      indicadorMontoDestino: [this.producto ? this.producto.indicadorMontoDestino : false],
      indicadorHojaEvaluacion: [this.producto ? this.producto.indicadorHojaEvaluacion : false],
      indicadorManejaGarantia: [this.producto ? this.producto.indicadorManejaGarantia : false],
      indicadorAplicaGarantiaIdonea: [this.producto ? this.producto.indicadorAplicaGarantiaIdonea : false],
      indicadorHabilitado: [this.producto ? this.producto.indicadorHabilitado : false],
      indicadorDuplicarDireccionNegocio: [this.producto ? this.producto.indicadorDuplicarDireccionNegocio : false],
      indicadorAprobacionPlanPago: [this.producto ? this.producto.indicadorAprobacionPlanPago : false],
      indicadorSeguroVoluntarioPreaprobado: [this.producto ? this.producto.indicadorSeguroVoluntarioPreaprobado : false],
      auditoriaUsuario: [this.producto ? this.producto.auditoriaUsuario : null],
      auditoriaFecha: [this.producto ? this.producto.auditoriaFecha : null],
      nombreTipoCupo: [this.producto ? this.producto.nombreTipoCupo : null],
      diaDePrimerPago: [this.producto ? this.producto.diaDePrimerPago : null],
      diaHastaPrimerPago: [this.producto ? this.producto.diaHastaPrimerPago : null],
      nombreClasificacion: [this.producto ? this.producto.nombreClasificacion : null],
      montoMinimo: [
        this.producto ? this.producto.montoMinimo : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.required, Validators.maxLength(10)] : []
      ],
      montoMaximo: [
        this.producto ? this.producto.montoMaximo : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.required, Validators.maxLength(10)] : []
      ],
      plazoMinimo: [
        this.producto ? this.producto.plazoMinimo : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.required, Validators.maxLength(3)] : []
      ],
      plazoMaximo: [
        this.producto ? this.producto.plazoMaximo : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.required, Validators.maxLength(3)] : []],
      plazoMinimoFrecuencia: [
        this.producto ? this.producto.plazoMinimoFrecuencia : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.maxLength(4)] : []
      ],
      plazoMaximoFrecuencia: [
        this.producto ? this.producto.plazoMaximoFrecuencia : null,
        this.codeTipoProductoBancario !== TiposProductosBancarios.AHORRO && this.codeTipoProductoBancario !== TiposProductosBancarios.PASARELA
        ? [Validators.maxLength(4)] : []
      ],
      icono: [this.producto ? this.producto.icono : null],
      indicadorManejaDctoTasa: [this.producto ? this.producto.indicadorManejaDctoTasa : false],
      indicadorNoAplicaDescuentoPerfilRiesgo: [ this.producto ? this.producto.indicadorNoAplicaDescuentoPerfilRiesgo : false],
      indicadorNoRequiereUnidadCredito: [this.producto ? !this.producto.indicadorRequiereUnidadCredito : false],
      indicadorEspecial: [this.producto ? this.producto.indicadorEspecial : false],
      indicadorFlujoCaja: [this.producto ? this.producto.indicadorFlujoCaja : false],
      indicadorLibranza: [this.producto ? this.producto.indicadorLibranza : false],
      indicadorRotativo: [this.producto ? this.producto.indicadorRotativo : false],
      indicadorAgremiacionAliado: [this.producto ? this.producto.indicadorAgremiacionAliado : false],
      tercerosGremios: [ [] ],
      indicadorAlertas: [this.producto ? this.producto.indicadorAlertas : false],
      indicadorConfirmacionVinculacion: [this.producto ? this.producto.indicadorConfirmacionVinculacion : false],
      indicadorDesembolso: [this.producto ? this.producto.indicadorDesembolso : false],
      // indicadorEspecies: [ this.producto ? this.producto.indicadorEspecies : false ],
      indicadorMontoDestinoPerfil: [this.producto ? this.producto.indicadorMontoDestinoPerfil : false],
      indicadorReglasNegocio: [this.producto ? this.producto.indicadorReglasNegocio : false],
      indicadorRestricciones: [this.producto ? this.producto.indicadorRestricciones : false],
      indicadorVoluntadPago: [this.producto ? this.producto.indicadorVoluntadPago : false],
      indicadorCuestionario: [this.producto ? this.producto.indicadorCuestionario : false],
      indicadorCicloInterno: [this.producto ? this.producto.indicadorCicloInterno : false],
      indicadorPeriodoGracia: [this.producto ? this.producto.indicadorPeriodoGracia : false],
      indicadorRecogeCredito: [this.producto ? this.producto.indicadorRecogeCredito : false],
      idAdjuntoIcono: [this.producto ? this.producto.idAdjuntoIcono : null],
      resenaDigital: [this.producto ? this.producto.resenaDigital : null,
        this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO ? [Validators.required, Validators.maxLength(70)] : [Validators.maxLength(70)]
      ],
      nombreAdjuntoIcono: [this.producto ? this.producto.nombreAdjuntoIcono : false],
      orden: [this.producto ? this.producto.orden : (this.obtenerOrdenMayor() + 1)],
      idTipoTasas: [null],
      idTasaVariable: [null],
      puntosTasaVariable: [null],
      idTipoValor: [this.producto ? this.producto.idTipoValor : null],
      idSolicitudTasaEspecial: [this.producto ? this.producto.idSolicitudTasaEspecial : null],
      idTipoProductoBancario: [this.producto ? this.producto.idTipoProductoBancario : this.idTipoProductoBancario],
      idTipoCuenta: [this.producto ? this.producto.idTipoCuenta : null, this.codeTipoProductoBancario === TiposProductosBancarios.AHORRO
        ? [Validators.required]
        : []],
      idMedioAsociado: [null],
      rentabilidad: [this.producto ? this.producto.rentabilidad : null, this.codeTipoProductoBancario === TiposProductosBancarios.AHORRO
        ? [Validators.required]
        : []],
      impuestoFinanciero: [this.producto ? this.producto.impuestoFinanciero : false],
      idTiposSolicitudesLlaves: [null],
      indicadorEjecutivo: [this.producto ? this.producto.indicadorEjecutivo : false],
      indicadorFreelance: [this.producto ? this.producto.indicadorFreelance : false],
      codigoTipoProductoBancario: [this.producto ? this.producto.codigoTipoProductoBancario : null],
      idTiposTitulosInversiones: [
        this.producto ? this.producto.idTiposTitulosInversiones : null,
        this.codeTipoProductoBancario == TiposProductosBancarios.INVERSION && !this.producto?.idTiposTitulosInversiones ? [Validators.required] : []
      ],
      tiposTitulosInversion: [ this.producto ? this.producto.tiposTitulosInversion : null ],
      idsTiposIntereses: [
        this.productoTiposIntereses.filter(e => e.indicadorHabilitado).map(e => e.idTipoInteres),
        this.codeTipoProductoBancario == TiposProductosBancarios.INVERSION ? [Validators.required] : []
      ],
      idCanalInversiones: [
        this.producto ? this.producto.idCanalInversiones : null,
        this.codeTipoProductoBancario == TiposProductosBancarios.INVERSION ? [Validators.required] : []
      ],
      indicadorAplicaRenovacionAutomatica: [ this.producto ? this.producto.indicadorAplicaRenovacionAutomatica : false ],
      indicadorBotonPse: [ this.producto ? this.producto.indicadorBotonPse : false ],
      indicadorAplicaAdjunto: [ this.producto ? this.producto.indicadorAplicaAdjunto : false ],
      indicadorNotificacionEmpleados: [this.producto ? this.producto.indicadorNotificacionEmpleados : false],
      indicadorNotificacionAdministrativos: [this.producto ? this.producto.indicadorNotificacionAdministrativos : false],
      cantidadEmpleados: [
        this.producto ? this.producto.cantidadEmpleados : null,
        this.producto?.indicadorNotificacionEmpleados ? [Validators.required, Validators.min(1), Validators.maxLength(3)] : []
      ],
      cantidadAdministrativos: [
        this.producto ? this.producto.cantidadAdministrativos : null,
        this.producto?.indicadorNotificacionAdministrativos ? [Validators.required, Validators.min(1), Validators.maxLength(3)] : []
      ],
      indicadorRestriccionPorCancelacion: [this.producto ? this.producto.indicadorRestriccionPorCancelacion : false],
      horasRestriccionCancelacion: [
        this.producto ? (this.producto.horasRestriccionCancelacion ?? null) : null,
        this.producto?.indicadorRestriccionPorCancelacion ? [Validators.required, Validators.maxLength(5)] : []
      ],
      indicadorProductoSaldado: [this.producto ? this.producto.indicadorProductoSaldado : false],
      horasRestriccionSaldado: [
        this.producto ? (this.producto.horasRestriccionSaldado ?? null) : null,
        this.producto?.indicadorProductoSaldado ? [Validators.required, Validators.maxLength(5)] : []
      ],
    });
    this.loadFormListeners();
    this.setearCampoRequeridoTasa();
    this.datosPeriodoGracia();

    forkJoin(this.lisServicio.getMasterDetails('ListasSolicitudesTasasEspeciales'),
      this.lisServicio.getMasterDetails('ListasTiposCuposProductos'),
      this.lisServicio.getMasterDetails('ListasClasificacionesProductos'),
      this.lisServicio.getMasterDetails('ListasTiposCuotas'),
      this.lisServicio.getMasterDetails('ListasTiposPeriodoGracia'),
      this.modalidadService.listadoModalidadesHabilitadas(),
      this.conConstanteService.getByCode('FSIZE'),
      this.lisServicio.getMasterDetails('ListasTiposRecogerCarteras'),
      this.lisServicio.getMasterDetails('ListasTiposTasasProductos'), this.tasasVariables.listadoHabilitado(),
      this.lisServicio.getMasterDetails('ListasTiposCuentasAhorros'),
      this.lisServicio.getMasterDetails('ListasTiposMediosAsociadosCuentas'),
      this.lisServicio.getMasterDetails('ListasTiposSolicitudesLlaves'),
      this.lisServicio.getMasterDetails( 'ListasTiposPersonas' ),
      this.lisServicio.getMasterDetails(Listas.LISTAS_TIPOS_TITULOS_INVERSIONES),
      this.lisServicio.getMasterDetails(Listas.LISTAS_TIPOS_INTERESES),
      this.lisServicio.getMasterDetails(Listas.LISTAS_CANALES_CDTS),
      this.terceroService.obtenerTercerosGremios(),
      this.setearProductoTasa(),
      this.setearProductoMediosAsociados(),
      this.setearProductosSolicitudesLlaves(),
      this.setearProductosAgremiaciones()
    ).subscribe(([listasSolicitudesTasasEspeciales, cupos, clasificaciones, listaTiposCuotas, listaTipoPeriodo, modalidades, tamMaximo,
                   listatipoCartera, listaTipoTasasProductos, listaTasasVariables,
                   listaTipoCuenta, listaTiposMediosAsociados, listaTiposSolicitudesLlaves, listaTiposPersonas, listaTipoTituloInversion, listaTipoInteres, listaCanalesCDTS,
                   resTercerosGremios]) => {


      this.lisTercerosGremios = (resTercerosGremios || []).map(g => ({
        label: `${g.nombreCompleto ? g.nombreCompleto.trim() : ''} - ${g.codigoTipoDocumento ?? ''} ${g.numeroDocumento ?? ''}`,
        value: g.idTercero
      }));
      this.listaTipoCuenta = listaTipoCuenta.map(s => ({label: s.nombre, value: s.idLista}));
      this.lisTipoCuenta = listaTipoCuenta;
      this.listasTiposPersonas = listaTiposPersonas.map( s => ( { label: s.nombre, value: s.idLista } ) );
      this.listaTiposMediosAsociados = listaTiposMediosAsociados.map(s => ({label: s.nombre, value: s.idLista}));
      this.lisTiposMediosAsociados = listaTiposMediosAsociados;

      this.listaTiposSolicitudesLlaves = listaTiposSolicitudesLlaves.map(s => ({label: s.nombre, value: s.idLista}));
      this.lisTiposSolicitudesLlaves = listaTiposSolicitudesLlaves;

      this.lisCupos = cupos.map(s => ({label: s.nombre, value: s.idLista}));
      this.lisClasificaciones = clasificaciones.map(s => ({label: s.nombre, value: s.idLista}));
      this.listaTiposCuotas = listaTiposCuotas.map(s => ({label: s.nombre, value: s.idLista}));
      this.lisModalidades = modalidades.map(m => {
        const mTemp: SelectItem = {} as SelectItem;
        mTemp.value = m.idModalidad;
        mTemp.label = m.nombre;
        return mTemp;
      });
      this.listasSolicitudesTasasEspeciales = listasSolicitudesTasasEspeciales.map(s => ({label: s.nombre, value: s.idLista}));
      this.listaTipoPeriodo = listaTipoPeriodo.map(s => ({label: s.nombre, value: s.idLista}));
      this.listaTipoCartera = [];
      this.lisTipoCarteras = listatipoCartera;
      this.listaTipoCartera = listatipoCartera.map(s => ({label: s.nombre, value: s.idLista}));
      this.listaTipoTasasProductoTodas = listaTipoTasasProductos;
      this.listaTiposTasasProducto = this.listaTipoTasasProductoTodas.map(s => ({label: s.nombre, value: s.idLista}));
      this.listaTasasVariablesTodas = listaTasasVariables;
      this.listaTasasVariables = this.listaTasasVariablesTodas.map(s => ({label: s.tasaVariable, value: s.idTasaVariable}));
      this.fsize = (tamMaximo && tamMaximo.valor) ? Number(tamMaximo.valor) : 50000000;
      this.listaTipoTituloInversion = listaTipoTituloInversion.map(e => ({ label: e.nombre, value: e.idLista }));
      this.listaTipoInteres = listaTipoInteres.map(e => ({ label: e.nombre, value: e.idLista }));
      this.listaCanalesCDTS = listaCanalesCDTS.map(e => ({ label: e.nombre, value: e.idLista }));


      this.f.idTipoTasas.setValue(this.idTipoTasaProducto);
      this.f.idMedioAsociado.setValue(this.idMediosAsociadosProducto);
      this.f.idTiposSolicitudesLlaves.setValue(this.idSolicitudesLlavesProducto);
      if (this.idTipoTasaProducto.length > 0) {
        this.activarTasaVariable(this.idTipoTasaProducto, true);
      }

      const idsDisponibles = new Set((this.lisTercerosGremios || []).map(item => item.value));
      const idsHabilitados = (this.productosAgremiacionesGuardados || [])
        .filter(x => x.indicadorHabilitado && x.idTercero)
        .map(x => x.idTercero)
        .filter(id => idsDisponibles.has(id));
      this.f.tercerosGremios.setValue(idsHabilitados);

      this.carInformacionInicial = false;
      this.cambioIndicadorAgremiacionAliado(this.f.indicadorAgremiacionAliado?.value);
    });
  }

  async setearProductoTasa(): Promise<any | null> {
    if (!this.producto?.idProducto) return null;
    this.idTipoTasaProducto = [];
    this.productoTasas = await this.productosTasas.listadoHabilitadoxProducto(this.producto.idProducto).toPromise();
    this.productoTasas.forEach( x => {
      if (x.indicadorHabilitado) {
        this.idTipoTasaProducto.push(x.idTipoTasaProducto);
      }
    });
  }

  async setearProductoMediosAsociados(): Promise<any | null>{
    if (!this.producto?.idProducto) return null;

    this.idMediosAsociadosProducto = [];
    this.productosMediosAsociados = await this.productosMediosAsociadosService.listadoHabilitadoxProducto(this.producto.idProducto).toPromise();
    this.productosMediosAsociados.forEach( x => {
      if (x.indicadorHabilitado) {
        this.idMediosAsociadosProducto.push(x.idMedioAsociado);
      }
    });
  }

  async setearProductosSolicitudesLlaves() : Promise<any | null>{
    if (!this.producto?.idProducto) return null;

    this.idSolicitudesLlavesProducto = [];
    this.productosSolicitudesLlaves = await this.productosSolicitudesService.listadoHabilitadoxProducto(this.producto.idProducto).toPromise();
    this.productosSolicitudesLlaves.forEach( x => {
      if (x.indicadorHabilitado) {
        this.idSolicitudesLlavesProducto.push(x.idSolicitudesLlaves);
      }
    });
  }

  async setearProductosAgremiaciones(): Promise<any | null> {
    if (!this.producto?.idProducto) return null;
    try {
      this.productosAgremiacionesGuardados = await firstValueFrom(
        this.productosAgremiacionesService.listadoPorProducto(this.producto.idProducto)
      );
    } catch (error) {
      console.error('Error al cargar agremiaciones del producto', error);
      this.productosAgremiacionesGuardados = [];
    }
  }

  cambioIndicadorAgremiacionAliado(check: boolean): void {
    if (check) {
      this.f.tercerosGremios.setValidators([Validators.required]);
    } else {
      this.f.tercerosGremios.clearValidators();
    }
    this.f.tercerosGremios.updateValueAndValidity();
  }

  async actualizarProductosAgremiaciones(): Promise<void> {
    if (!this.producto?.idProducto) return;

    const indAgremiacion = this.f.indicadorAgremiacionAliado?.value;
    const idsSeleccionados: string[] = (indAgremiacion && this.f.tercerosGremios?.value)
      ? this.f.tercerosGremios.value.filter((id: string) => !!id)
      : [];
    const listaBulk: any[] = [];
    const usuario = this.autServicio.obtenerIdUsuarioLogueado();

    // 1. Procesar seleccionados actualmente por el usuario
    idsSeleccionados.forEach((idTercero: string) => {
      const existente = this.productosAgremiacionesGuardados?.find(e => e.idTercero === idTercero);
      if (existente) {
        const copiaExistente = { ...existente };
        copiaExistente.indicadorHabilitado = true;
        copiaExistente.auditoriaUsuario = usuario;
        listaBulk.push(copiaExistente);
      } else {
        listaBulk.push({
          idProducto: this.producto.idProducto,
          idTercero: idTercero,
          auditoriaUsuario: usuario,
          indicadorHabilitado: true
        });
      }
    });

    // 2. Procesar registros previamente guardados que ya no están seleccionados o inválidos
    this.productosAgremiacionesGuardados?.forEach(e => {
      if (e.indicadorHabilitado && (!e.idTercero || !idsSeleccionados.includes(e.idTercero))) {
        const copiaInhabilitar = { ...e };
        copiaInhabilitar.indicadorHabilitado = false;
        copiaInhabilitar.auditoriaUsuario = usuario;
        listaBulk.push(copiaInhabilitar);
      }
    });

    if (listaBulk.length > 0) {
      try {
        await firstValueFrom(this.productosAgremiacionesService.bulk(listaBulk));
        this.productosAgremiacionesGuardados = await firstValueFrom(
          this.productosAgremiacionesService.listadoPorProducto(this.producto.idProducto)
        );
      } catch (error) {
        console.error('Error al actualizar productos agremiaciones en bulk', error);
      }
    }
  }

  setearCampoRequeridoTasa() {
    if(this.codeTipoProductoBancario != TiposProductosBancarios.CREDITO){
      return;
    }

    this.f.idTipoTasas.clearValidators();
    if (this.f.indicadorManejaTasa.value === true) {
      this.f.idTipoTasas.setValidators([]);
      this.f.idTipoTasas.setValue([]);
    } else {
      this.f.idTipoTasas.setValidators([Validators.required]);
      this.f.idTipoTasas.setValue([]);
      return;
    }
  }

  obtenerOrdenMayor() {
    let maximo = this.lisProducto[0];
    for (let i = 1; i < this.lisProducto.length; i++) {
      if (this.lisProducto[i].orden > maximo.orden) {
        maximo = this.lisProducto[i];
      }
    }
    return maximo.orden;
  }

  recogerCartera()  {
    if (this.f.indicadorRecogeCredito.value === true) {
      this.f.idTipoCartera.setValidators([Validators.required]);
      this.f.idTipoCartera.setValue(null);
    } else {
      this.f.idTipoCartera.setValidators([]);
      this.f.idTipoCartera.setValue(null);
      return;
    }
  }

  datosPeriodoGracia() {
    if(this.codeTipoProductoBancario === TiposProductosBancarios.AHORRO){
      return;
    }
    if (this.producto && this.producto.idProducto && this.producto.indicadorPeriodoGracia) {
      this.productosPeriodosGraciasService.getByIdProducto(this.producto.idProducto).subscribe(dataPeriodo => {
        if (dataPeriodo && dataPeriodo.idProductoPeriodoGracia) {
          this.productosPeriodosGracias = dataPeriodo;
          if (this.productosPeriodosGracias.indicadorOpcional) {
            this.estadoValorMinimo = false;
          }
        }
        this.loadFormPeriodoGracias();
      });
    } else {
      this.loadFormPeriodoGracias();
    }
  }

  loadFormPeriodoGracias() {

    this.formularioPeriodoGracia = this.fb.group({
      idProductoPeriodoGracia: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.idProductoPeriodoGracia : null ],
      idProducto: [ this.producto ? this.producto.idProducto : null ],
      indicadorOpcional: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.indicadorOpcional : false ],
      plazoMinimo: [ this.productosPeriodosGracias && this.productosPeriodosGracias.plazoMinimo > 0 ? this.productosPeriodosGracias.plazoMinimo : 0 ],
      plazoMaximo: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.plazoMaximo : null, [ Validators.required ] ],
      idTipoPeriodoGracia: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.idTipoPeriodoGracia : null, [ Validators.required ] ],
      indicadorIntereses:  [ this.productosPeriodosGracias ? this.productosPeriodosGracias.indicadorIntereses : false ],
      indicadorCapital: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.indicadorCapital : false ],
      indicadorOtrosConceptos: [ this.productosPeriodosGracias ? this.productosPeriodosGracias.indicadorOtrosConceptos : false ]
    });

    this.formularioConceptos = this.fb.group({
      conceptos: [null, [Validators.required]],
    });

    this.loadConceptos();

  }

  loadConceptos() {
    this.carInformacionInicial = true;
    this.formularioConceptos.reset();
    this.listaConceptosAsignados = [];
    this.listaConceptos = [];
    this.conceptoFacturacionService.listado().subscribe(conceptos => {
      if (this.productosPeriodosGracias.idProductoPeriodoGracia) {
          this.productosPeriodosGraciasOtrosConceptosService.getByIdProductoPeriodoGracia(this.productosPeriodosGracias.idProductoPeriodoGracia).subscribe(conceptosAsig => {
          this.listaConceptosAsignados = conceptosAsig;
          conceptos.map((c: ConceptoFacturacion) => {
            if (Array.isArray(conceptosAsig)) {
              if (conceptosAsig.find(x => x.idConceptoFacturacion === c.idConceptoFacturacion) === undefined) {
                this.listaConceptos.push({label: c.nombre, value: c.idConceptoFacturacion });
              }
            } else {
              this.listaConceptos.push({label: c.nombre, value: c.idConceptoFacturacion });
            }

          });
            this.carInformacionInicial = false;
          this.loadingConceptos = false;
        });
      } else {
        conceptos.map((c: ConceptoFacturacion) => {
          this.listaConceptos.push({label: c.nombre, value: c.idConceptoFacturacion });
        });
        this.loadingConceptos = false;
        this.carInformacionInicial = false;
      }
    });
  }

  cambioTabSeleccionado( event ) {
    let indice = event.index;

    if ( !this.producto.indicadorAlertas && indice >= 1 ) {
      indice++;
    }

    if ( !this.producto.indicadorFlujoDigital && indice >= 3 ) {
      indice++;
    }

    if ( this.codeTipoProductoBancario != this.codigosProducto.INVERSION && indice >= 4 ) {
      indice++;
    }

    if ( !this.producto.indicadorConfirmacionVinculacion && indice >= 5 ) {
      indice++;
    }

    if ( !this.producto.indicadorCuestionario && indice >= 7 ) {
      indice++;
    }

    if ( !this.producto.indicadorDesembolso && indice >= 8 ) {
      indice++;
    }

    if ( (this.producto.indicadorMontoDestino || this.producto.indicadorMontoDestinoPerfil) && indice >= 9 ) {
      indice++;
    }

    /*
    if ( !this.producto.indicadorEspecies && indice >= 10 ) {
      indice++;
    } */

    if ( !this.producto.indicadorHojaEvaluacion && indice >= 13 ) {
      indice++;
    }

    if ( ( this.producto.indicadorMontoDestino || this.producto.indicadorMontoDestinoPerfil ) && indice >= 14 ) {
      indice++;
    }

    if ( !this.producto.indicadorMontoDestinoPerfil && indice >= 15 ) {
      indice++;
    }

    if ( !this.producto.indicadorMontoDestino && indice >= 16 ) {
      indice++;
    }

    if ( !this.producto.indicadorRenovable && indice >= 20 ) {
      indice++;
    }

    if ( !this.producto.indicadorManejaGarantia && indice >= 21 ) {
      indice++;
    }

    if ( !this.producto.indicadorRestricciones && indice >= 22 ) {
      indice++;
    }

    if ( !this.producto.indicadorVoluntadPago && indice >= 23 ) {
      indice++;
    }

    switch ( indice ) {
      case 1:
        this.lisTabCargados.alerta = true;
        break;
      case 2:
        this.lisTabCargados.autorizacion = true;
        break;
      case 3:
        this.lisTabCargados.camposDigitales = true;
        break;
      case 5:
        this.lisTabCargados.confirmacionVincualcion = true;
        break;
      case 6:
        this.lisTabCargados.controlAnalizamos = true;
        break;
      case 7:
        this.lisTabCargados.cuestionarios = true;
        break;
      case 8:
        this.lisTabCargados.desembolso = true;
        break;
      case 9:
        this.lisTabCargados.destino = true;
        break;
      case 10:
        this.lisTabCargados.estado = true;
        break;
      case 11:
        this.lisTabCargados.frecuencias = true;
        break;
      case 12:
        this.lisTabCargados.flujoVentaPaso = true;
        break;
      case 13:
        this.lisTabCargados.hojaEvaluacion = true;
        break;
      case 14:
        this.lisTabCargados.monto = true;
        break;
      case 15:
        this.lisTabCargados.montoAliado = true;
        break;
      case 16:
        this.lisTabCargados.montodestino = true;
        break;
      case 17:
        this.lisTabCargados.plancargo = true;
        break;
      case 18:
        this.lisTabCargados.seguroAnalizamos = true;
        break;
      case 19:
        this.lisTabCargados.referencia = true;
        break;
      case 20:
        this.lisTabCargados.renovacion = true;
        break;
      case 21:
        this.lisTabCargados.garantias = true;
        break;
      case 22:
        this.lisTabCargados.restricciones = true;
        break;
      case 23:
        this.lisTabCargados.voluntadPago = true;
        break;


      default:
        this.lisTabCargados.producto = true;
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'identificacion',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisProducto.find( x => x.codigo === this.f.codigo.value && x.codigoTipoProductoBancario === this.codeTipoProductoBancario ) ? true : false;
  }

  ValidarPlazo() {
    let minimo = this.f.plazoMinimoFrecuencia.value;
    let maximo = this.f.plazoMaximoFrecuencia.value;
    const minLleno = ( minimo !== undefined && minimo !== null && minimo !== '' );
    const maxLleno = ( maximo !== undefined && maximo !== null && maximo !== '' );
    this.plazoCorrecto = ( minLleno || maxLleno ) ? ( ( minLleno && maxLleno ) ? Number( minimo ) < Number( maximo ) : false ) : true;
    this.f.plazoMinimoFrecuencia.setValidators( ( minLleno || maxLleno ) ? [ Validators.required, Validators.maxLength( 4 ) ] : [] );
    this.f.plazoMaximoFrecuencia.setValidators( ( minLleno || maxLleno ) ? [ Validators.required, Validators.maxLength( 4 ) ] : [] );
    this.f.plazoMinimoFrecuencia.updateValueAndValidity();
    this.f.plazoMaximoFrecuencia.updateValueAndValidity();
  }


  get f() {
    return this.formulario.controls;
  }

  get pg() {
    return this.formularioPeriodoGracia.controls;
  }

  get c() {
    return this.formularioConceptos.controls;
  }

  onSubmit() {
    this.guardando = true;
    this.validarRango();
    this.validarPlazo();
    this.submitted = true;
    const producto = this.formulario.value ;
    if(this.codeTipoProductoBancario === TiposProductosBancarios.CREDITO && !this.f.indicadorEjecutivo.value && !this.f.indicadorFreelance.value){
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_ERRORFUERZACOMERCIAL' )
      } );
      this.guardando = false;
      return;
    }
    if (this.f.indicadorManejaDctoTasa.value) {
      if (!this.f.tasaMaximaEspecial.value || !this.f.idSolicitudTasaEspecial.value) {
        this.guardando = false;
        return;
      }
    } else {
      this.f.idSolicitudTasaEspecial.setValue(null);
      this.f.tasaMaximaEspecial.setValue(null);
    }
    if ( !producto.indicadorComercializacionOficinas ) {
      producto.diaDePrimerPago = null;
      producto.diaHastaPrimerPago = null;
      this.formulario.controls.diaDePrimerPago.setValue( null );
      this.formulario.controls.diaHastaPrimerPago.setValue( null );
    }
    producto.indicadorRequiereUnidadCredito = !producto.indicadorNoRequiereUnidadCredito;
    this.relIndicadorAliadoOficina = this.codeTipoProductoBancario == TiposProductosBancarios.CREDITO ? ( !producto.indicadorComercializacionAliados && !producto.indicadorComercializacionOficinas ) ? true : false: false;
    if ( !this.codExiste && this.formulario.valid && !this.relIndicadorAliadoOficina && !this.ranIncorrecto && !this.plaIncorrecto && this.plazoCorrecto && !this.ranPrimerPagoIncorrecto ) {
      if ( producto.idProducto ) {
        this.validarModalidad( producto );
      } else {
        this.proServicio.crear( producto ).subscribe(async rta => {
          this.producto = producto;
          this.producto.idProducto = rta.idProducto;
          this.f.idProducto.setValue( rta.idProducto );
          await this.actualizarProductoTasa();
          await this.actualizarProductosSolicitudesLlaves();
          await this.actualizarProductosMediosAsociados();
          await this.actualizarProductosAgremiaciones();
          await this.guardarTiposIntereses();
          this.navServicio.setMesage( 1 );
          this.guardando = false;
          this.submitted = false;
          this.commService.enviarPrimerComponent( producto );
        }, error => {
          this.navServicio.setMesage( 3 );
          this.guardando = false;
        } );
      }
    } else {
      if ( !this.plazoCorrecto ) {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_ERRORPLAZO' )
        } );
      }
      this.guardando = false;
    }
  }


  onSubmitPeriodoGracia() {
    this.submitted = true;
    console.log(this.formularioPeriodoGracia);
    if (this.formularioPeriodoGracia.valid) {
      this.guardando = true;
      const productosPeriodosGracias = this.formularioPeriodoGracia.value;
      if ((this.productosPeriodosGracias.idProductoPeriodoGracia !== null &&
          this.productosPeriodosGracias.idProductoPeriodoGracia !== undefined &&
          this.productosPeriodosGracias.idProductoPeriodoGracia !== undefined)) {
        if (this.productosPeriodosGracias.indicadorOtrosConceptos && this.listaConceptosAsignados.length === 0 ) {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_CONCEPTOS' )
          } );
          this.guardando = false;
          this.submitted = false;
          this.tabViewIndex = 1;
          return;
        }
        this.productosPeriodosGraciasService.update(productosPeriodosGracias).subscribe(periodos => {
          this.productosPeriodosGracias = periodos;
          this.confirmacionPeriodoGracia();
          this.navServicio.setMesage( 2 );
        }, error => {
          this.navServicio.setMesage(3);
          this.guardando = false;
        });
      } else {
          this.productosPeriodosGraciasService.add(productosPeriodosGracias).subscribe(periodos => {
            this.productosPeriodosGracias = periodos;
            this.confirmacionPeriodoGracia();
            this.navServicio.setMesage( 1 );
          }, error => {
            this.navServicio.setMesage( 3 );
            this.guardando = false;
          });
      }
    }
  }

  confirmacionPeriodoGracia() {
    this.guardando = false;
    this.submitted = false;
    if (this.productosPeriodosGracias.indicadorOtrosConceptos) {
       this.tabViewIndex = 1;
    } else {
      this.commService.enviarPrimerComponent( this.producto );
    }

  }

  onSubmitConceptos() {
    this.submitted = true;
    if (this.formularioConceptos.valid) {
      this.guardando = true;
      const conceptosAsignados = this.c.conceptos.value ;
      const newDataConceptos = [];
      conceptosAsignados.forEach(c => {
        const objproductosPeriodosGraciasOtrosConceptos = new ProductosPeriodosGraciasOtrosConceptos();
        objproductosPeriodosGraciasOtrosConceptos.idProductoPeriodoGracia = this.productosPeriodosGracias.idProductoPeriodoGracia;
        objproductosPeriodosGraciasOtrosConceptos.indicadorHabilitado = true;
        objproductosPeriodosGraciasOtrosConceptos.idConceptoFacturacion = c;
        newDataConceptos.push(objproductosPeriodosGraciasOtrosConceptos);
      });
     this.productosPeriodosGraciasOtrosConceptosService.bulk(newDataConceptos).subscribe(respData => {
       this.navServicio.setMesage( 1 );
       this.guardando = false;
       this.loadConceptos();

     }, error => {
       this.navServicio.setMesage( 3 );
       this.guardando = false;
       this.submitted = false;
     });

    }
  }

  deshabilitarConceptos(data: ProductosPeriodosGraciasOtrosConceptos) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_ELIMINACION' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'identificacion',
      accept: () => {
        data.indicadorHabilitado = false;
        this.productosPeriodosGraciasOtrosConceptosService.update(data).subscribe(restUpdate => {
          this.loadConceptos();
        }, error => {
          this.navServicio.setMesage( 3 );
        });
      }
    } );
  }

  validarModalidad( producto: any ) {
    if ( this.producto && this.producto.idModalidad !== producto.idModalidad ) {
      this.proAutorizacionServicio.listadoPorProducto( producto.idProducto ).subscribe( listado => {
        if ( listado.find( x => x.indicadorHabilitado ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_EXISTENAUTORIZACIONES' )
          } );
          this.guardando = false;
        } else {
          this.lisTabCargados.autorizacion = false;
          this.actualizarProducto( producto );
        }
      } );
    } else {
      this.actualizarProducto( producto );
    }
  }

  actualizarProducto( producto: any ) {
    this.proServicio.actualizar( producto ).subscribe(async rta => {
      this.producto = producto;
      await this.actualizarProductoTasa();
      await this.actualizarProductosSolicitudesLlaves();
      await this.actualizarProductosMediosAsociados();
      await this.actualizarProductosAgremiaciones();
      await this.guardarTiposIntereses();
      this.navServicio.setMesage( 2 );
      this.guardando = false;
      this.submitted = false;
      this.commService.enviarPrimerComponent( producto );
    }, error => {
      this.navServicio.setMesage( 3 );
      this.guardando = false;
    } );
  }

  actualizarProductoTasa() {
    const _listaTipoTasas = this.f.idTipoTasas.value;
    const listaSeleccionadaProductoTasa = [];
    _listaTipoTasas.forEach(x => {
      const objProductoTasas = Object.assign({} as ProductosTasas);
      const _tasa = this.listaTipoTasasProductoTodas.find(l => l.idLista === x);
      if (_tasa) {
        const _existeTasaproducto = this.productoTasas.find(p => p.idTipoTasaProducto === _tasa.idLista);
        if (_existeTasaproducto) {
          _existeTasaproducto.indicadorHabilitado = true;
          _existeTasaproducto.idTasaVariable = _tasa.codigo === TasasProducto.TASVAR ? this.f.idTasaVariable.value : null;
          _existeTasaproducto.puntosTasaVariable = _tasa.codigo === TasasProducto.TASVAR ? this.f.puntosTasaVariable.value : null;
          listaSeleccionadaProductoTasa.push(_existeTasaproducto);
        } else {
          objProductoTasas.idProducto = this.producto.idProducto;
          objProductoTasas.idTipoTasaProducto = _tasa.idLista;
          objProductoTasas.idTasaVariable = _tasa.codigo === TasasProducto.TASVAR ? this.f.idTasaVariable.value : null;
          objProductoTasas.puntosTasaVariable = _tasa.codigo === TasasProducto.TASVAR ? this.f.puntosTasaVariable.value : null;
          objProductoTasas.indicadorHabilitado = true;
          listaSeleccionadaProductoTasa.push(objProductoTasas);
        }
      }


    });
    /*Validar registros que se inhabilitan*/
    this.productoTasas.forEach(pt => {
      const _reg = listaSeleccionadaProductoTasa.find(l => l.idTipoTasaProducto === pt.idTipoTasaProducto);
      if (!_reg) {
        pt.indicadorHabilitado = false;
        listaSeleccionadaProductoTasa.push(pt);
      }
    });
    this.productosTasas.bulk(listaSeleccionadaProductoTasa).toPromise();

  }


  actualizarProductosSolicitudesLlaves() {
    const _listaSolicitudesLlaves = this.f.idTiposSolicitudesLlaves.value;
    const listaSeleccionadaProductoTasa = [];
    _listaSolicitudesLlaves.forEach(x => {
      const objProductosSolicitudesLlaves = Object.assign({} as ProductosSolicitudesLlaves);
      const _tasa = this.lisTiposSolicitudesLlaves.find(l => l.idLista === x);
      if (_tasa) {
        const _existeTasaproducto = this.productosSolicitudesLlaves.find(p => p.idSolicitudesLlaves === _tasa.idLista);
        if (_existeTasaproducto) {
          _existeTasaproducto.indicadorHabilitado = true;
          listaSeleccionadaProductoTasa.push(_existeTasaproducto);
        } else {
          objProductosSolicitudesLlaves.idProducto = this.producto.idProducto;
          objProductosSolicitudesLlaves.idSolicitudesLlaves = _tasa.idLista;
          objProductosSolicitudesLlaves.indicadorHabilitado = true;
          listaSeleccionadaProductoTasa.push(objProductosSolicitudesLlaves);
        }
      }


    });
    /*Validar registros que se inhabilitan*/
    this.productosSolicitudesLlaves.forEach(pt => {
      const _reg = listaSeleccionadaProductoTasa.find(l => l.idSolicitudesLlaves === pt.idSolicitudesLlaves);
      if (!_reg) {
        pt.indicadorHabilitado = false;
        listaSeleccionadaProductoTasa.push(pt);
      }
    });
    this.productosSolicitudesService.bulk(listaSeleccionadaProductoTasa).toPromise();
  }


  actualizarProductosMediosAsociados() {
    const _listaMediosAsociados = this.f.idMedioAsociado.value;
    const listaSeleccionadaProductoTasa = [];
    _listaMediosAsociados.forEach(x => {
      const objProductosSolicitudesLlaves = Object.assign({} as ProductosMediosAsociados);
      const _tasa = this.lisTiposMediosAsociados.find(l => l.idLista === x);
      if (_tasa) {
        const _existeTasaproducto = this.productosMediosAsociados.find(p => p.idMedioAsociado === _tasa.idLista);
        if (_existeTasaproducto) {
          _existeTasaproducto.indicadorHabilitado = true;
          listaSeleccionadaProductoTasa.push(_existeTasaproducto);
        } else {
          objProductosSolicitudesLlaves.idProducto = this.producto.idProducto;
          objProductosSolicitudesLlaves.idMedioAsociado = _tasa.idLista;
          objProductosSolicitudesLlaves.indicadorHabilitado = true;
          listaSeleccionadaProductoTasa.push(objProductosSolicitudesLlaves);
        }
      }


    });
    /*Validar registros que se inhabilitan*/
    this.productosMediosAsociados.forEach(pt => {
      const _reg = listaSeleccionadaProductoTasa.find(l => l.idMedioAsociado === pt.idMedioAsociado);
      if (!_reg) {
        pt.indicadorHabilitado = false;
        listaSeleccionadaProductoTasa.push(pt);
      }
    });
    this.productosMediosAsociadosService.bulk(listaSeleccionadaProductoTasa).toPromise();
  }

  seleccionarFechaInicial( fecha: any ) {
    const d = new Date( Date.parse( fecha ) );
    d.setDate( d.getDate() + 1 );
    this.minFechaFinal = d;
    if ( this.f.fechaFinVigencia.value && moment( this.f.fechaFinVigencia.value ).diff( moment( this.minFechaFinal ), 'days' ) < 0 ) {
      this.f.fechaFinVigencia.setValue( null );
    }
  }

  seleccionarFechaFinal( fecha: any ) {
    const d = new Date( Date.parse( fecha ) );
    d.setDate( d.getDate() - 1 );
    this.maxFechaInicial = d;
    if ( this.f.fechaInicioVigencia.value && moment( this.f.fechaInicioVigencia.value ).diff( moment( this.maxFechaInicial ), 'days' ) > 0 ) {
      this.f.fechaInicioVigencia.setValue( null );
    }
  }

  cambioManejaTasa( checked: boolean ) {
    this.f.tasa.clearValidators();
    this.submitted = false;
    if ( checked ) {
      this.f.tasa.setValidators( [ Validators.required, Validators.maxLength( 9 ) ] );
      this.habilitarTasaVariable = false;
      this.f.idTasaVariable.setValidators([]);
      this.f.idTasaVariable.setValue(null);
      this.f.puntosTasaVariable.setValidators([]);
      this.f.puntosTasaVariable.setValue(null);
    } else {
      this.f.tasa.setValue( null );
      this.f.tasa.setValidators( [ Validators.maxLength( 9 ) ] );
    }
    this.setearCampoRequeridoTasa();
  }

  activarTasaVariable( event: any, cargaInicial: boolean = false) {
    this.habilitarTasaVariable = false;
    let _listaIds = [];
    if (cargaInicial) {
      _listaIds = event;
    } else {
      _listaIds = event.value;
    }
    if (_listaIds.length > 0) {
      _listaIds.forEach(x => {
       const _buscar = this.listaTipoTasasProductoTodas.find(l => l.idLista === x);
       if (_buscar && _buscar.codigo === TasasProducto.TASVAR) {
         this.habilitarTasaVariable = true;
       }
      });
      if (this.habilitarTasaVariable) {
        if (cargaInicial) {
          const _tasaVariable = this.productoTasas.find(t => t.codigoTipoTasaProducto === TasasProducto.TASVAR && t.indicadorHabilitado);
          if (_tasaVariable) {
            this.f.idTasaVariable.setValue(_tasaVariable.idTasaVariable);
            this.f.puntosTasaVariable.setValue(_tasaVariable.puntosTasaVariable);
          }
        }
        this.f.idTasaVariable.setValidators([Validators.required]);
        this.f.puntosTasaVariable.setValidators([Validators.required]);
      } else {
        this.f.idTasaVariable.setValidators([]);
        this.f.idTasaVariable.setValue(null);
        this.f.puntosTasaVariable.setValidators([]);
        this.f.puntosTasaVariable.setValue(null);
      }
    }
  }

  habilitarProducto( estado: boolean ) {
    this.habProducto = true;
    if ( estado ) {

      if(this.codeTipoProductoBancario === TiposProductosBancarios.AHORRO
       || this.codeTipoProductoBancario === TiposProductosBancarios.INVERSION ) {
        this.producto.indicadorHabilitado = true;
        this.proServicio.actualizar( this.producto ).subscribe( producto => {
          this.f.indicadorHabilitado.setValue( true );
          this.navServicio.setMesage( 2 );
          this.habProducto = false;
        } );
        return;
      }



      this.proServicio.validarHabilitarProducto( this.producto.idProducto ).subscribe( validacion => {
        const llaves = Object.keys( validacion );
        let mensaje = '';
        llaves.map( ( s: any ) => {
          if ( !validacion[ s ] ) {
            mensaje = mensaje + s + ',';
          }
        } );

        if ( mensaje.length > 0 ) {
          mensaje = mensaje.substring( 0, mensaje.length - 1 );
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOHABILITAR' ) + ' ' + mensaje
          } );
          this.habProducto = false;
        } else {
          this.producto.indicadorHabilitado = true;
          this.proServicio.actualizar( this.producto ).subscribe( producto => {
            this.f.indicadorHabilitado.setValue( true );
            this.navServicio.setMesage( 2 );
            this.habProducto = false;
          } );
        }

      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_INHABILITARPRODUCTO' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'identificacion',
        accept: () => {
          this.producto.indicadorHabilitado = false;
          this.proServicio.actualizar( this.producto ).subscribe( producto => {
            this.f.indicadorHabilitado.setValue( false );
            this.navServicio.setMesage( 2 );
            this.habProducto = false;
            this.location.back();
          } );
        },
        reject: () => {
          this.habProducto = false;
        }
      } );
    }

  }

  validarRango() {
    const inferior = this.f.montoMinimo.value;
    const superior = this.f.montoMaximo.value;
    this.ranIncorrecto = ( inferior && superior && Number( inferior ) >= Number( superior ) ) ? true : false;
  }

  validarPlazo() {
    const inferior = this.f.plazoMinimo.value;
    const superior = this.f.plazoMaximo.value;
    this.plaIncorrecto = ( inferior && superior && Number( inferior ) >= Number( superior ) ) ? true : false;
  }

  validarRangoPrimerPago() {
    const inferior = this.f.diaDePrimerPago.value;
    const superior = this.f.diaHastaPrimerPago.value;
    this.ranPrimerPagoIncorrecto = ( inferior && superior && Number( inferior ) >= Number( superior ) ) ? true : false;
    if ( inferior || superior ) {
      this.f.diaDePrimerPago.setValidators( [ Validators.required ] );
      this.f.diaHastaPrimerPago.setValidators( [ Validators.required ] );
      this.f.diaDePrimerPago.updateValueAndValidity();
      this.f.diaHastaPrimerPago.updateValueAndValidity();
    }
    if ( !inferior && !superior ) {
      this.f.diaDePrimerPago.setValidators( [] );
      this.f.diaHastaPrimerPago.setValidators( [] );
      this.f.diaDePrimerPago.setValue( null );
      this.f.diaHastaPrimerPago.setValue( null );
    }
  }


  abrirAcordeon( evento: number ) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'PRODUCTO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'INDICADORES';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'PERIODOGRACIA';
        break;
      }
      default: {
        break;
      }
    }
  }

  validarMontos(checked: boolean, campo: string) {

    if(checked){
      if(campo === 'Monto'){
        this.f.indicadorMontoDestino.setValue(true);
        this.f.indicadorMontoDestinoPerfil.setValue(false);
      } else if(campo === 'Perfil'){
        this.f.indicadorMontoDestino.setValue(false);
        this.f.indicadorMontoDestinoPerfil.setValue(true);
      }
    }

  }

  cambiarTabOnClick( event ) {
    this.tabViewIndex = event.index;
  }



  cambiarEstadovalorMinimo(checked: boolean) {
    if (checked) {
      this.estadoValorMinimo = false;
    } else {
      this.estadoValorMinimo = true;
      this.pg.plazoMinimo.setValue(0);
    }
  }

  validarMaximo() {
    if (this.pg.plazoMaximo.value < this.pg.plazoMinimo.value) {
      this.pg.plazoMaximo.setValue(null);
    }
  }

  estadoAgregarConceptos (checked: boolean) {
    if (checked) {
      this.productosPeriodosGracias.indicadorOtrosConceptos = true;
    } else {
      this.productosPeriodosGracias.indicadorOtrosConceptos = false;
    }
  }

  setearValoresProducto(event: any ) {
    this.producto = event;
    this.f.idTipoValor.setValue( this.producto ? this.producto.idTipoValor : null);
  }

  async guardarTiposIntereses(): Promise<void> {
    const idsTiposIntereses: string[] = this.formulario?.value?.idsTiposIntereses || [];
    const productoTiposIntereses: ProductoTipoInteres[] = [];

    idsTiposIntereses.forEach((idTipoInteres: string) => {
      const tipoInteres: ProductoTipoInteres = {
        idTipoInteres,
        idProducto: this.producto?.idProducto,
        indicadorHabilitado: true
      } as ProductoTipoInteres;

      const existente: ProductoTipoInteres = this.productoTiposIntereses.find(e => e.idTipoInteres === idTipoInteres);
      if (existente) {
        tipoInteres.idProductoTipoInteres = existente.idProductoTipoInteres;
      }

      productoTiposIntereses.push(tipoInteres);
    });

    this.productoTiposIntereses.forEach(e => {
      if(e.idTipoInteres && e.indicadorHabilitado && !idsTiposIntereses.includes(e.idTipoInteres)) {
        e.indicadorHabilitado = false;
        productoTiposIntereses.push(e);
      }
    });

    this.productoTiposIntereses = await firstValueFrom(this.productoTipoInteresService.bulk(productoTiposIntereses));
  }

  loadFormListeners(): void {
    this.f.idTiposTitulosInversiones?.valueChanges.subscribe((newValue) => {
      const selectedOption = this.listaTipoTituloInversion.find(e => e.value === newValue);
      if (selectedOption) {
        this.f.tiposTitulosInversion?.setValue(selectedOption.label, { emitEvent: false });
      }
    });
  }
  validarIndRotativoLibranza(control: string,event: boolean ) {
    console.log(event);
    if (control === 'indicadorRotativo' && event && this.f.indicadorLibranza.value){
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_ALERTAROTATIVO' )
      } );
      this.f.indicadorLibranza.setValue(false);
    }
    if (control === 'indicadorLibranza' && event && this.f.indicadorRotativo.value){
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_ALERTALIBRANZA' )
      } );
      this.f.indicadorRotativo.setValue(false);
    }
  }

  /**
   * Habilita o limpia el campo de cantidad asociado a un indicador de notificación de pasarela
   *
   * @param nomIndicador nombre del control del checkbox
   * @param nomCantidad  nombre del control de cantidad asociado
   */
  cambioNotificacion(nomIndicador: string, nomCantidad: string) {
    const marcado = this.f[nomIndicador].value;
    if (!marcado) {
      this.f[nomCantidad].setValue(null);
    }
    this.f[nomCantidad].setValidators(marcado ? [Validators.required, Validators.min(1), Validators.maxLength(3)] : []);
    this.f[nomCantidad].updateValueAndValidity();
  }

  /**
   * Habilita o limpia el campo de horas asociado a un indicador de restricción
   *
   * @param nomIndicador nombre del control del checkbox
   * @param nomHoras     nombre del control de horas asociado
   */
  cambioRestriccion(nomIndicador: string, nomHoras: string) {
    const marcado = this.f[nomIndicador].value;
    if (!marcado) {
      this.f[nomHoras].setValue(null);
      this.f[nomHoras].setValidators([]);
    } else {
      if (this.f[nomHoras].value === null || this.f[nomHoras].value === undefined || this.f[nomHoras].value === '') {
        this.f[nomHoras].setValue(null);
      }
      this.f[nomHoras].setValidators([Validators.required, Validators.maxLength(5)]);
    }
    this.f[nomHoras].updateValueAndValidity();
  }

}
